exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".autocomplete {\n  display: flex;\n  flex-direction: column;\n  position: relative; }\n  .autocomplete input, .autocomplete input:focus {\n    width: 100%;\n    line-height: 100%;\n    background: transparent;\n    border: none;\n    outline: none; }\n  .autocomplete input::placeholder {\n    color: #5d5555;\n    opacity: 1; }\n  .autocomplete ul {\n    position: absolute;\n    top: 4rem;\n    width: 100%;\n    list-style: none;\n    font-size: 1.2em;\n    padding: 0.5rem 0;\n    z-index: 2;\n    background: #fff;\n    border-radius: 4px; }\n    .autocomplete ul li {\n      padding: 0.5rem 2.5rem; }\n    .autocomplete ul .marked {\n      background: #fcd9d9; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/Autocomplete/Autocomplete.scss
// module id = 1519
// module chunks = 0